// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9928096c","669":"c149d7e3"}[chunkId] + ".chunk.js";
};